import React from 'react';
import { Box, FormField, Input, Text, ToggleSwitch } from '@wix/design-system';
import { DataHooks } from '../../../../../../constants/dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';

export const AppNameSection = ({
  name,
  setName,
  nameError,
  namespaceError,
  isNameValidating,
  setIsValidated,
  showAdvanced,
  setShowAdvanced,
}: AppNameSectionProps) => {
  const { t } = useTranslation();

  return (
    <Box marginTop="SP1" direction="vertical">
      <FormField
        label={t('app.template.page.blocks.namespace.modal.label.name')}
        labelPlacement="top"
      >
        <Input
          dataHook={DataHooks.BlocksModalNameInput}
          value={name}
          autoFocus={true}
          size="large"
          onChange={(e) => {
            setIsValidated(false);
            setName(e.target.value);
          }}
          status={
            isNameValidating ? 'loading' : nameError ? 'error' : undefined
          }
          statusMessage={t(nameError)}
        />
      </FormField>
      {showAdvanced ? null : (
        <Box marginTop="SP2">
          <Text size="small" dataHook={DataHooks.BlocksModalShowAdvancedText}>
            {t('app.template.page.blocks.namespace.modal.field.helper.text')}
          </Text>
        </Box>
      )}
      <Box marginTop="SP4" display="block">
        <FormField
          label={t('app.template.page.blocks.namespace.modal.toggle')}
          labelPlacement="right"
          stretchContent={false}
          infoContent={t(
            'app.template.page.blocks.namespace.modal.toggle.tooltip',
          )}
        >
          <ToggleSwitch
            dataHook={DataHooks.BlocksModalShowAdvancedToggle}
            checked={showAdvanced}
            onChange={() => setShowAdvanced(!showAdvanced)}
            size="small"
            disabled={!!showAdvanced && !!namespaceError}
          />
        </FormField>
      </Box>
    </Box>
  );
};

export type AppNameSectionProps = {
  name: string;
  setName: (name: string) => void;
  nameError: string;
  namespaceError: string;
  isNameValidating: boolean;
  setIsValidated: (isValidated: boolean) => void;
  showAdvanced: boolean;
  setShowAdvanced: (showAdvanced: boolean) => void;
};
